import { HubConnectionBuilder, LogLevel, HubConnection } from '@microsoft/signalr';

export abstract class HubService {
  public readonly hubConnection: HubConnection;

  constructor(url: string) {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(url)
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    this.hubConnection
      .start()
      .then()
      .catch((err: unknown) => {
        console.error(`Hub couldn't start:`, err);
      });
  }
}
